<div class="modal">
  <div class="close-link">
    <span class="close" [mat-dialog-close]></span>
  </div>
  <h2 mat-dialog-title>{{ 'pages.tables.content.linkDevice' | translate }}</h2>

  <form class="modal__form" novalidated [formGroup]="newWidgetCodeForm">
    <mat-tab-group class="table-connection-tabs" (selectedIndexChange)="onConnectionTypeChange($event)">
      <mat-tab label="{{ 'pages.tables.modal.widgetCodeTab' | translate }}">
        <mat-form-field class="login-wrap__text">
          <input matInput appFormInputTrim formControlName="widgetCode">
          <mat-error *ngIf="newWidgetCodeForm.controls.widgetCode.touched && newWidgetCodeForm.controls.widgetCode.invalid">
            <span *ngIf="newWidgetCodeForm.controls.widgetCode.errors?.required">
              {{ 'pages.tables.modal.mandatoryField' | translate }}
            </span>
          </mat-error>
        </mat-form-field>
      </mat-tab>

      <mat-tab label="{{ 'pages.tables.modal.dwallDeviceIdTab' | translate }}">
        <mat-form-field class="login-wrap__text">
          <input matInput appFormInputTrim inputmode="numeric" maxlength="12" formControlName="dwallDeviceId">
          <mat-error *ngIf="newWidgetCodeForm.controls.dwallDeviceId.touched && newWidgetCodeForm.controls.dwallDeviceId.invalid">
            <span *ngIf="newWidgetCodeForm.controls.dwallDeviceId.errors?.required">
              {{ 'pages.tables.modal.mandatoryField' | translate }}
            </span>
            <span *ngIf="newWidgetCodeForm.controls.dwallDeviceId.errors?.pattern">
              {{ 'pages.tables.modal.dwallDeviceIdPattern' | translate }}
            </span>
          </mat-error>
        </mat-form-field>
      </mat-tab>
    </mat-tab-group>
  </form>

  <mat-dialog-actions align="center" class="menu">
    <button
      color="primary"
      mat-stroked-button
      [disabled]="newWidgetCodeForm.invalid"
      (click)="linkNewDevice()"
    >{{ 'pages.tables.modal.ok' | translate }}</button>
    <button mat-stroked-button mat-dialog-close>{{ 'pages.tables.modal.cancel' | translate }}</button>
  </mat-dialog-actions>
</div>
